<template>
  <div class="user-manage-box vice-president" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <p class="label">商品品牌：</p>
              <el-select
                v-model="filter.bid"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="btn-box">
            <!-- <button class="search" @click="order2excel">导出</button> -->
            <button class="search" @click="authorizationModal">
              开通
            </button>
          </div>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="brandName"
            align="center"
            label="关联商品品牌"
          >
            <div slot-scope="scope">{{ scope.row.brandName && scope.row.brandName.length ? scope.row.brandName.join('，') : '' }}</div>
          </el-table-column>
          <el-table-column prop="created" align="center" label="开通日期">
            <div slot-scope="scope">
              {{ scope.row.created | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <div
              slot-scope="scope"
              style="display: flex; justify-content: center"
            >
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="authorizationModal(scope.row)"
                >
                  编辑
                </button>
              </div>
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBrandRole(scope.row)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="authorizationShow"
      @close="selectGoodsVisible = false"
      class="dialog"
      width="618px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">{{
       info.id ? '编辑身份' : '开通身份' 
      }}</div>
      <el-form
        ref="form"
        :model="authorizationForm"
        class="authorization-form"
        label-width="auto"
      >
        <el-form-item label="用户ID" prop="uid" class="form-item">
          <input
            placeholder="输入用户ID"
            class="input"
            v-model.number="authorizationForm.uid"
            type="number"
            :disabled="info.uid"
            style="width: 185px;box-sizing: border-box;"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
        <el-form-item label="选择品牌" prop="uid" class="form-item">
          <el-select
            v-model="authorizationForm.brand"
            multiple
            filterable
            placeholder="请选择"
            size="small"
            style="width: 185px;box-sizing: border-box;"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="authorizationShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAuthorization"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '商品品牌方'
      },
      filter: {
        // 过滤条件
        bid: null,
        uid: null,
      },
      userList: [], // 用户列表
      uid: null,
      authorizationForm: {
        uid: null,
        brand: []
      },
      authorizationShow: false,
      role: [],
      roleMap: {},
      brandList: [],
      paginationKey: +new Date(), // 分页按钮key值，用于刷新分页
      info: {}
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.name !== 'userDetail' && from.name !== 'popularize') {
  //     sessionStorage.setItem('userManage', '');
  //   }
  //   next();
  // },
  mounted() {
    // let data = sessionStorage.getItem('userManage')
    //   ? JSON.parse(sessionStorage.getItem('userManage'))
    //   : '';
    // if (data) {
    //   this.filter = {
    //     ...this.filter,
    //     ...data.filter
    //   };
    //   this.date = data.date;
    //   this.currentPage = data.currentPage;
    //   this.paginationKey = +new Date();
    //   this.setSearchData();
    // }
    // 获取列表
    this.getUserList();
    this.getBrandList();
  },
  computed: {},
  methods: {
    setSearchData() {
      // let userManage = {
      //   currentPage: this.currentPage,
      //   filter: this.filter,
      //   date: this.date
      // };
      // sessionStorage.setItem('userManage', JSON.stringify(userManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取用户列表
    getUserList() {
      this.setSearchData();
      this.loading++;
      this.httpGet(this.$root.getBrandRoleList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getBrandList() {
        this.loading++;
        this.httpGet(this.$root.getBrandList, {
        }).then(
        (res) => {
            this.loading--;
            this.brandList = res.list;
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    authorizationModal(rowData = {}) {
      if(rowData.uid){
        this.info = rowData;
        this.authorizationForm = {
            uid: rowData.uid,
            brand: rowData.brandId.split(',').map(item => +item)
        };
      } else {
        this.info = {};
        this.authorizationForm = {
            uid: null,
            brand: []
        };
      }
    //   this.$refs.form && this.$refs.form.clearValidate();
      this.authorizationShow = true;
    },
    // 身份授权
    handleAuthorization() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          let url = this.$root.openAgent;
          let obj = {uid: this.authorizationForm.uid};
          if(this.info.uid) {
            url = this.$root.updateBrandRole;
            obj = {id: this.info.id}
          };
          this.httpPut(url, {
            ...obj,
            brandId: this.authorizationForm.brand.join(','),
            newRole: 8
          }).then(
            (res) => {
              this.loading--;
              this.authorizationShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getUserList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    // 过滤
    search() {
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        bid: null,
        uid: null,
      };
      this.date = [];
      this.getUserList();
    },
    deleteBrandRole(rowData){
        this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteBrandRole, {
          id: rowData.id,
          uid: rowData.uid,
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
.select-goods >>>.el-table__header{
  .el-checkbox{
    display: none !important;
  }
}
.user-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 40px;
      }

      .select, .input {
        width: 128px;
      }

      .date-input {
        width: 225px;
      }

      .btn-box {
        margin: 0;
        .search{
          width: auto;
          min-width: 65px;
          padding: 0 12px;
        }
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
  .authorization-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 32px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
</style>
